// 样式建议
import styled from 'styled-components';

export const VerifyFormWrapper = styled.div`
  .ant-input-group.ant-input-group-compact {
    .ant-input {
      border-radius: 6px 0 0 6px !important;
      width: calc(100% - var(--wh-88));
    }
  }
`;

export const VeriryResultWrapper = styled.div`
  width: 100%;
`;

export const LoggerSNVeriryResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: var(--gap-4);

  width: 100% !important;
`;

export const PSIDVeriryResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: var(--gap-4);

  width: 100% !important;
`;

export const ResultInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: var(--gap-16);
  padding: var(--gap-16);
  box-sizing: border-box;

  background: var(--black-light-185);

  @media (max-width: 576px) {
    flex-direction: column;
    justify-content: center;
  }
`;

export const LoggerModeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--gap-16);

  @media (max-width: 576px) {
    flex-direction: column;
    justify-content: center;
  }
`;